import React, { useEffect, useState } from "react";
import api from "../../api";
import { messageOf } from "./SignatureApi";
export async function downloadEnrollmentPdf(id) {
  const { data } = await api.get(`/signatures/enrollment/${id}/document.pdf`, {
    responseType: "blob",
  });
  const url = URL.createObjectURL(
    new Blob([data], { type: "application/pdf" }),
  );
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = "documento-identificacao.pdf";
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export default function EnrollmentRecord({ record, administrative = false }) {
  const [urls, setUrls] = useState(null),
    [error, setError] = useState("");
  const kinds = record.hasPhotoDocument
    ? ["document", "photo-document", "selfie"]
    : ["document", "selfie"];
  useEffect(() => {
    setUrls(null);
    setError("");
    let alive = true;
    const links = [];
    Promise.all(
      (record.hasPhotoDocument
        ? ["document", "photo-document", "selfie"]
        : ["document", "selfie"]
      ).map(async (kind) => {
        const { data } = await api.get(
          `/signatures/enrollment/${record.id}/images/${kind}`,
          { responseType: "blob" },
        );
        if (!alive) return null;
        const url = URL.createObjectURL(data);
        links.push(url);
        return url;
      }),
    )
      .then((result) => {
        if (alive) setUrls(result);
      })
      .catch((e) => {
        if (alive) setError(messageOf(e));
      });
    return () => {
      alive = false;
      links.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [record.id, record.hasPhotoDocument]);
  return (
    <section
      className="signature-card"
      aria-label={
        administrative
          ? "Registros de identificação do usuário"
          : "Meus registros de identificação"
      }
    >
      <p className="signature-help">
        Acesso privado até{" "}
        {new Date(record.expiresAt).toLocaleDateString("pt-BR")}.
      </p>
      {error && (
        <p role="alert" className="signature-error">
          {error}
        </p>
      )}
      {urls ? (
        <div className="signature-enrollment-grid">
          {urls.map((url, index) => (
            <figure key={url}>
              <img
                src={url}
                alt={
                  kinds[index] === "photo-document"
                    ? "Documento complementar com foto"
                    : administrative
                      ? kinds[index] === "selfie"
                        ? "Foto de identificação do usuário"
                        : "Documento de identificação do usuário"
                      : kinds[index] === "selfie"
                        ? "Minha selfie registrada"
                        : "Meu documento registrado"
                }
              />
              <figcaption>
                {kinds[index] === "photo-document"
                  ? "Documento com foto"
                  : kinds[index] === "selfie"
                    ? "Selfie"
                    : "Documento dos dados"}
              </figcaption>
            </figure>
          ))}
        </div>
      ) : (
        !error && <p role="status">Carregando registros privados…</p>
      )}
      {record.sourcePdfAvailable && (
        <button
          type="button"
          onClick={() =>
            downloadEnrollmentPdf(record.id).catch((e) =>
              setError(messageOf(e)),
            )
          }
        >
          Baixar PDF original
        </button>
      )}
    </section>
  );
}
